import { useState, createContext } from "react";

export const UserContext = createContext({});

export default function UserProvider({children}){

    const [userDoContext, setUserDoContext] = useState('')

    return(
        <UserContext.Provider value={{userDoContext, setUserDoContext}}>
            {children}
        </UserContext.Provider>
    )
}